import IsNextYearEarlyRegistrationContext from '@/contexts/IsNextYearEarlyRegistrationContext';
import { StepContext } from '@/contexts/StepContext';
import useSponsors from '@/hooks/useSponsors';
import { Grid, Paper } from '@mui/material';
import { IFormLookupFilterProps, Select, Text } from '@ngt/forms';
import { Condition, ConditionMode, useScopedField } from '@ngt/forms-core';
import { useContext, useMemo } from 'react';
import * as Dtos from '../../../api/dtos';
import RegistrationField from '../../RegistrationField';
import SponsorLevel from '../SponsorLevel';

const valueSubscription = {
    value: true
};

const studentOrRegistrarOrTrialCoordinatorSelectedCondition = ({value}: any) => value?.student === true || value?.trialCoordinator === true || value?.registrar === true;

const RegistrationStepTwo = () => {
    const isNextYearEarlyRegistration = useContext(IsNextYearEarlyRegistrationContext);

    const filterTypes = useMemo(() => {
        const output: IFormLookupFilterProps<Dtos.Registration> = {
            filterFunction: (formState, propertyPath, lookup) => {
                if (isNextYearEarlyRegistration) {
                    return {
                        ...lookup,
                        items: lookup?.items?.filter(x => x.id === 8)
                    };
                }
                if (!formState.value?.staffConfirmed) {
                    return {
                        ...lookup,
                        items: lookup?.items?.filter(x => x.id !== 5 && x.id !== 7 && x.id !== 8) 
                    }
                }
                
                return {
                    ...lookup,
                    items: lookup?.items?.filter(x => x.id !== 8) 
                }
            },
            subscription: { value: true }
        }

        return output;
    }, [isNextYearEarlyRegistration]);

    const {
        state: {
            value: sponsor
        }} = useScopedField<boolean>('sponsor', valueSubscription);

    const { sponsors } = useSponsors();

    return (
        <StepContext.Provider value={1}>
            <Paper
                sx={{ p: 4, pt: 0, mt: { xs: 1, md: 3 } }}
            >
                <Grid 
                    container
                    columnSpacing={4}
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        mt={4}
                    >
                        {
                            sponsor?
                                // this is also a rego field because it simple holds all the strange logic for the steps so you can move past the point as well as
                                // returning the InputOnlyField......... ? 
                                <>
                                    <RegistrationField
                                        label="Sponsor"
                                        propertyPath="sponsorId"
                                        component={Select}
                                        sx={{margin:"normal"}}
                                        nullOption={false}
                                        FormControlProps={{
                                            variant: "standard"
                                        }}
                                        options={sponsors?.map((sponsor) => ({ value: sponsor.sponsorName, id: sponsor.id }))}
                                    />
                                    <SponsorLevel />
                                </>
                                :
                                <RegistrationField
                                    label="Registration Type"
                                    propertyPath="registrationType"
                                    component={Select}
                                    nullOption={false}
                                    FormControlProps={{
                                        variant: "standard"
                                    }}
                                    LookupFilterProps={filterTypes}
                                /> 
                        }
                        
                    </Grid>

                </Grid>
                <Condition
                    condition={studentOrRegistrarOrTrialCoordinatorSelectedCondition}
                    subscription = {{
                        value: true
                    }}
                    mode={ConditionMode.Show}
                >
                    <Grid 
                        container 
                        columnSpacing={4}
                    >
                        <Grid 
                            item
                            xs={12}
                            md={12}
                            mt={4}
                        >
                            <RegistrationField
                                label="Please enter the name of your supervisor"
                                propertyPath="supervisorName"
                                component={Text}
                                variant="standard"
                            />
                        </Grid>
                    </Grid> 
                </Condition>
            </Paper>
        </StepContext.Provider>
    );
}

export default RegistrationStepTwo;